import { render, staticRenderFns } from "./dialogMain.vue?vue&type=template&id=12bd3450&"
import script from "./dialogMain.vue?vue&type=script&lang=js&"
export * from "./dialogMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports